<app-table-standard-layout [dataSource$]="categories$" [title]="'Scheduled Routines'" [columnSettings]="columnSettings"
  [rowActionButtons]="rowActionButtons" [topbarActionButton]="topbarActionButton" [showImport]="false" >
</app-table-standard-layout>

<button class="theme-button" (click)="updateAgain()" >update again</button>
